"use strict";
exports.__esModule = true;
var capitalizeFirstLetter = function (stringToCapitialize) {
    return "".concat(stringToCapitialize
        .charAt(0)
        .toUpperCase()).concat(stringToCapitialize.slice(1));
};
exports["default"] = capitalizeFirstLetter;
